import { Sprite } from '../sprite';
import type { ISprite } from '../../../type/entity/sprite';

export class SpriteMotionDirection {
    private entity: Sprite;
    /**
     * @internal
     * @param entity {ISprite}
     */
    constructor(entity:ISprite){
        this.entity = entity as Sprite;
    }
    /**
     * 向き
     * @returns {number} - 向き
     */
    get degree() : number {
        return this.entity.Properties.degree;
    }
    /**
     * 向き
     * @param degree {number} - 向き
     */
    set degree(degree: number) {
        let _degree = degree % 360;
        if( _degree > 180 ) {
            _degree -= 360; // 179 => 180 => -179 => -178
        }
        this.entity.Properties.degree = _degree;
    }
};